import ItemHeroPage from './ItemHeroPage';

export default ItemHeroPage;
